// extracted by mini-css-extract-plugin
export default {"contIntro":"index_contIntro_aBw9V"};